import { useState } from "react";
import UsersManagement from "@/components/security/UsersManagement";
import { usePermissions } from "@/lib/permissions";
import { Navigate } from "react-router-dom";

/**
 * Standalone Users admin page (linked from the sidebar for admins only).
 * A read_only or soc_analyst user hitting /users directly gets redirected.
 */
export default function Users() {
  const { isAdmin } = usePermissions();
  if (!isAdmin) return <Navigate to="/" replace />;

  return (
    <div className="space-y-6 animate-fade-in" data-testid="users-page">
      <header>
        <div className="overline mb-2">Console · Administración</div>
        <h1 className="font-display font-bold tracking-tighter" style={{ fontSize: "clamp(36px, 4vw, 56px)" }}>
          Gestión de usuarios
        </h1>
        <p className="text-muted-foreground text-sm mt-1 max-w-2xl">
          Crea, edita y desactiva las cuentas del tenant. Cada usuario recibe uno de los tres roles
          canónicos: <span className="text-foreground">Administrador</span>,{" "}
          <span className="text-foreground">Analista SOC</span> o{" "}
          <span className="text-foreground">Solo lectura</span>.
        </p>
      </header>
      <UsersManagement />
    </div>
  );
}
